/**
 * Callback OAuth : échange le session_id (fragment d'URL) contre une session
 * persistante auprès du backend, puis redirige vers le dashboard.
 */
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get("session_id");

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    authApi
      .createSession(sessionId)
      .then(({ data }) => {
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { state: { user: data }, replace: true });
      })
      .catch(() => navigate("/login", { replace: true }));
  }, [navigate, setUser]);

  return (
    <div className="flex h-screen items-center justify-center bg-[#0B5394]">
      <div className="text-sm text-white">Connexion en cours...</div>
    </div>
  );
}
